import { buildCloudFrontUrl } from '@/utils/pathUtils';
import { uploadFileToS3 } from '@/utils/s3Utils';
import fontManagerService from '@/utils/fontManagerService';

(function () {
    'use strict';
    'ngInject';
    angular.module('app.ctrls').controller('HomeCtrl', homeCtrl);

    var ROW_HEIGHT = 53;
    var TABLE_OVERHEAD = 340; // toolbar + header + pagination + margins

    function calculateNumPerPage() {
        var available = (window.innerHeight || document.documentElement.clientHeight) - TABLE_OVERHEAD;
        var count = Math.floor(available / ROW_HEIGHT);
        return Math.max(count, 5); // minimum 5 rows
    }

    function homeCtrl(
        $scope,
        ProductAPIService,
        ProductService,
        $location,
        $mdDialog,
        $timeout,
        $window,
        blockUI,
        AppCuesService,
        $route,
        $mdToast,
        TemplatePermissionsService,
        UsersAPIService,
        TemplateAccessConstants
    ) {
        $scope.templateRelationDetails = {
            title: '',
            templateId: '',
            Products: [],
            OptionSets: [],
            Clients: [],
            isOpen: false,
            showDeleteMessage: false
        };
        $scope.openTemplateRelationDetailsModal = {
            isOpen: false,
            showDeleteMessage: false
        };

        $scope.showAuditLogModal = false;
        $scope.auditLogEntityType = 'T';
        $scope.auditLogEntityId = null;
        $scope.auditLogEntityCreatedDate = null;
        $scope.auditLogDisplayName = null;

        $scope.queryParams = $location.search();
        $scope.filteredProducts = [];
        $scope.currentPage = 1;
        $scope.numPerPage = calculateNumPerPage();
        $scope.maxSize = 5;

        var resizeHandler = function () {
            var newPerPage = calculateNumPerPage();
            if (newPerPage !== $scope.numPerPage) {
                $scope.numPerPage = newPerPage;
                $scope.$applyAsync();
            }
        };
        angular.element($window).on('resize', resizeHandler);
        $scope.$on('$destroy', function () {
            angular.element($window).off('resize', resizeHandler);
        });

        $scope.productCount = 0;
        $scope.linkedProductCount = 0;
        $scope.searchString = $scope.queryParams.templateId ?? $window.localStorage.getItem('search') ?? '';
        $scope.hasTemplateRelationDisabled = false;
        $scope.showOptionsButton = false;
        $scope.usernames = null;
        $scope.isAdminUser = false;
        $scope.isParentUser = false;
        $scope.isChildUser = false;
        $scope.templateIdCopied = '';
        $scope.sortMode = 'DESC';
        $scope.sortBy = 'ModifiedDate';
        let productPrevState = null;
        $scope.templateSort = 'all';
        $scope.areAllTemplatesSelected = false;
        $scope.templatesSelectedCount = 0;
        $scope.pages = new Set([1]);
        $scope.filterValues = [{ value: 'all', text: 'All templates' }];

        // Full access filter for readonlypluslisted users
        $scope.showFullAccessFilter = false;
        $scope.filterFullAccessOnly = false;

        $scope.isAllowedToExportTemplates = function (user) {
            return user && user.AccessRoles.Serialized.split(',').includes('templates-import-export');
        };

        // Init fonts load
        fontManagerService.initFonts();

        $scope.$on('route:success', async (_, user) => {
            if (!user) return;
            $scope.showOptionsButton = user.ShowCustomilyOptions;
            $scope.hasTemplateRelationDisabled = user.AccessRoles.Serialized.split(',').includes(
                'disable-template-relations'
            );
            if (!$scope.hasTemplateRelationDisabled) {
                $scope.filterValues.push(
                    { value: 'linked', text: 'Linked to products' },
                    { value: 'not', text: 'Not linked to products' }
                );
            }
            // If this user is and admin, show the dropdown to select the current user
            $scope.isAdminUser =
                (user.AccessRoles.Serialized.split(',').includes('admin') || user.ImpersonatedFromAdminUser) && !user.ImpersonatedFromChildUser;
            $scope.isParentUser =
                user.AccessRoles.Serialized.split(',').includes('parent') || user.ImpersonatedFromParentUser;

            // Check if user has readonlypluslisted access to show full access filter
            // Show filter for child users with restricted access (AllReadOnlyPlusListed)
            $scope.showFullAccessFilter = false;
            if (user.ImpersonatedFromChildUser) {
                try {
                    const accessRestrictionResponse = await UsersAPIService.getAccessRestriction(
                        user.UserImpersonatedFromId,
                        TemplateAccessConstants.ENTITY_TYPE.TEMPLATE
                    );
                    $scope.showFullAccessFilter =
                        accessRestrictionResponse.accessRestriction ===
                        TemplateAccessConstants.ACCESS_RESTRICTION.ALL_READ_ONLY_PLUS_LISTED;
                } catch (error) {
                    console.error('Error getting access restriction:', error);
                }
            }

            // UserReview, show?
            if (!$scope.isAdminUser && user.UserReview != null && user.UserReview.Show) {
                user.UserReview.Show = false;

                $mdDialog
                    .show({
                        controller: 'UserReviewModalCtrl',
                        template: require('../../../views/pages/user-review/userReview.html'),
                        parent: angular.element(document.body),
                        locals: {
                            msgType: user.UserReview.MessageType,
                            msgVal: user.UserReview.MessageValue
                        },
                        clickOutsideToClose: false,
                        escapeToClose: false
                    })
                    .then(() => {
                        console.log('userReview dialog closed');
                    });
            }
        });

        $scope.$watch('currentPage + numPerPage', function () {
            $scope.begin = ($scope.currentPage - 1) * $scope.numPerPage;
            $scope.end = $scope.begin + $scope.numPerPage;
            $scope.getProducts();
        });

        $scope.$on('$locationChangeStart', function (event) {
            if ($location.search().templateId) {
                $location.search('templateId', null);
                event.preventDefault();

                // Update the URL without query parameters
                $location.url($location.path());
            }
        });

        $scope.$on('$locationChangeSuccess', function () {
            if (!$route.current.$$route.keepSearch) $window.localStorage.removeItem('search');
        });

        $scope.$on('$routeChangeSuccess', function () {
            if ($location.search().templateId) $location.search('templateId', null);
        });

        $scope.onScopesTemplateRelationDetailsModalClose = function () {
            $scope.templateRelationDetails.isOpen = false;
            $scope.templateRelationDetails.showDeleteMessage = false;
        };

        $scope.onScopesAuditLogModalClose = function () {
            $scope.showAuditLogModal = false;
            $scope.auditLogEntityId = null;
            $scope.auditLogEntityCreatedDate = null;
            $scope.auditLogDisplayName = null;
        };

        $scope.getProducts = function () {
            const linked = ['all', 'deleted'].includes($scope.templateSort)
                ? undefined
                : $scope.templateSort === 'not'
                ? false
                : true;
            // Remove spaces
            $scope.searchString = $scope.searchString.trim();
            blockUI.start('Loading products');

            Promise.all([
                ProductAPIService.getProducts(
                    $scope.searchString,
                    $scope.sortBy,
                    $scope.sortMode,
                    $scope.begin,
                    $scope.numPerPage,
                    linked,
                    $scope.templateSort === 'deleted',
                    $scope.filterFullAccessOnly
                ),
                ProductAPIService.getProductsCount(
                    $scope.searchString,
                    linked,
                    $scope.templateSort === 'deleted',
                    $scope.filterFullAccessOnly
                )
            ]).then(([data, count]) => {
                $scope.filteredProducts = data.map(function (product) {
                    product['selected'] = false;
                    return product;
                });

                $scope.productCount = count;
                $scope.linkedProductCount = $scope.getLinkedTemplates()?.length;
                $scope.areAllTemplatesSelected = $scope.getAreAllTemplatesSelected();
                $scope.templatesSelectedCount = $scope.getSelectedTemplates()?.length;

                console.log('stop');
                blockUI.stop();
                $scope.$applyAsync();
            });
        };

        $scope.delete = async function (product, $event) {
            $event.stopPropagation();

            const canDelete = await $scope.canDeleteTemplate(product);
            if (!canDelete) {
                $mdDialog.show(
                    $mdDialog
                        .alert()
                        .title('Permission Denied')
                        .htmlContent('You do not have permission to delete this template.')
                        .ok('OK')
                );
                return;
            }

            var confirm = $mdDialog
                .confirm()
                .title('Delete Template')
                .htmlContent(
                    'Are you sure you want to delete "<b>' + product.name + '</b>" with id "<b>' + product.id + '</b>"?'
                )
                .ok('Yes')
                .cancel('No');
            $mdDialog.show(confirm).then(
                async function () {
                    // Delete the product
                    ProductAPIService.deleteProduct(product.ProductId)
                        .then(() => {
                            $scope.getProducts();
                        })
                        .catch((error) => {
                            console.log(error);
                            if (error.status === 422) {
                                if (error.data && error.data?.list) {
                                    const { Products, OptionSets, Clients } = error.data.list;
                                    $scope.templateRelationDetails.title = product.name;
                                    $scope.templateRelationDetails.templateId = product.id;
                                    $scope.templateRelationDetails.Products = Products;
                                    $scope.templateRelationDetails.OptionSets = OptionSets;
                                    $scope.templateRelationDetails.Clients = Clients;
                                    $scope.templateRelationDetails.isOpen = true;
                                    $scope.templateRelationDetails.showDeleteMessage = true;
                                }
                            }
                        });
                },
                function () {
                    // Do nothing
                }
            );
        };

        $scope.restore = function (product, $event) {
            $event.stopPropagation();
            var confirm = $mdDialog
                .confirm()
                .title('Restore Template')
                .htmlContent(
                    `<p>
                        Do you want to restore <b>${product.name}</b> with id <b>${product.id}</b>?
                    </p>
                    <b>Notice: The libraries that were in the trash will also be restored.</b>`
                )
                .ok('Yes')
                .cancel('No');
            $mdDialog.show(confirm).then(
                async function () {
                    blockUI.start('Restoring Template');
                    await ProductAPIService.restoreProduct(product.id);
                    await $scope.getProducts();
                    blockUI.stop();
                },
                function () {
                    // Do nothing
                }
            );
        };

        $scope.clone = function (product, $event) {
            $event.stopPropagation();

            blockUI.start('Clone Template');
            ProductAPIService.cloneProduct(product.id)
                .then(function () {
                    blockUI.stop();
                    $scope.getProducts();
                })
                .catch(function () {
                    blockUI.stop();
                });
        };

        $scope.auditTemplate = function (product, $event) {
            $event.stopPropagation();
            blockUI.stop();
            $scope.auditLogEntityId = product.id;
            $scope.auditLogEntityCreatedDate = new Date(product.createdDate);
            $scope.auditLogDisplayName = product.name;
            $scope.showAuditLogModal = true;
        };

        $scope.edit = function (id, $event) {
            if ($event) $event.stopPropagation();
            if ($scope.templateSort == 'deleted') return;
            blockUI.start('Loading template...');
            $window.localStorage.setItem('search', $scope.searchString);
            ProductAPIService.getProduct(id).then(function (p) {
                ProductService.loadProduct(p);
                blockUI.stop();
                let newParams = new URLSearchParams($scope.queryParams);
                if (newParams.has('templateId')) newParams.delete('templateId');
                $location.url('/createProduct1?' + newParams);
            });
        };

        $scope.editInNewTab = function (id, $event) {
            if ($event) $event.stopPropagation();
            if ($scope.templateSort == 'deleted') return;
            const url = '/createProduct1?' + new URLSearchParams({ templateId: id });
            const newWindow = $window.open(url, '_blank', 'noopener');
            if (newWindow) newWindow.opener = null;
        };

        // Start adding a new product
        $scope.addProduct = function () {
            ProductService.clearProduct();
            $window.localStorage.setItem('search', $scope.searchString);
            let newParams = new URLSearchParams($scope.queryParams);
            if (newParams.has('templateId')) newParams.delete('templateId');
            $location.url('/createProduct1?' + newParams);
        };

        $scope.importTemplateFromCustomilyDesign = function () {
            $location.url('/store/create/template/customily-designs');
        };

        // Name edit
        $scope.editItem = function (product, $event) {
            $event.stopPropagation();
            if ($scope.templateSort == 'deleted') return;
            product.editing = true;
            // Save the previous state of the product in case the user cancels the edit
            productPrevState = JSON.parse(JSON.stringify(product));
            $timeout(() => $event?.currentTarget?.nextElementSibling?.focus(), 100);
        };

        $scope.cancelEditItem = function (product) {
            product.editing = false;
            productPrevState = null;
        };

        $scope.exportTemplate = async function (product, $event) {
            $event.stopPropagation();

            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(document.body)
                        .clickOutsideToClose(true)
                        .title('Export template')
                        .htmlContent(
                            `Once you click "Export template" the exporting process will begin. It can take a couple of minutes so please be patient.<br/>If prompted with an "Almost there screen", wait a couple of minutes and refresh the page to download the exported template.`
                        )
                        .ok('Export template')
                )
                .then(() => {
                    blockUI.start();
                    ProductAPIService.getExportUrl(product.id)
                        .then((url) => {
                            blockUI.stop();
                            window.open(url, '_blank');
                        })
                        .catch((error) => {
                            window.rumReportError(error);
                            blockUI.stop();
                        });
                });
        };

        $scope.uploadProductZip = async function (event) {
            const files = event.target.files;
            if (files && files[0]) {
                try {
                    // Upload the ZIP file to S3
                    blockUI.start('Uploading zip');
                    const zipFile = files[0];
                    const urlResponse = await ProductAPIService.getProductImportSignedUrl();
                    await uploadFileToS3(urlResponse.SignedUrl, urlResponse.Mime, zipFile, null, (progress) => {
                        blockUI.message(`Uploading zip ${parseInt(progress)}%`);
                        $timeout(() => $scope.$apply());
                    });

                    // Import the uploaded ZIP
                    blockUI.message('Importing template');
                    const newProductId = await ProductAPIService.importProductZip(urlResponse.Name);
                    blockUI.stop();

                    $mdDialog.show(
                        $mdDialog
                            .alert()
                            .parent(document.body)
                            .clickOutsideToClose(true)
                            .title('Template import')
                            .htmlContent(`Template imported with ID '${newProductId}'`)
                            .ok('OK')
                    );

                    // Force reload newly added fonts
                    fontManagerService.clearFontsCache();
                    fontManagerService.initFonts();

                    // Reload products
                    $scope.getProducts();
                } catch (error) {
                    console.error(error);
                    $mdDialog.show(
                        $mdDialog
                            .alert()
                            .parent(document.body)
                            .clickOutsideToClose(true)
                            .title('Template import error')
                            .htmlContent(`Something wrong happened while importing the template!`)
                            .ok('OK')
                    );
                } finally {
                    $('#productImportInput').get(0).value = null;
                }
            }
        };

        $scope.onEditingProductHandler = function (product, $event) {
            $event.stopPropagation();
            if (product.editing && String(product.name).trim() !== String(productPrevState.name).trim()) {
                $scope.doEditing(product);
                window.DD_RUM &&
                    window.DD_RUM.addAction('renameTemplate', {
                        value: true
                    });
            } else {
                $scope.cancelEditItem(product);
                window.DD_RUM &&
                    window.DD_RUM.addAction('renameTemplate', {
                        value: false
                    });
            }
        };

        $scope.doEditing = async function (product) {
            if (product.name) {
                try {
                    product.editing = false;
                    blockUI.start();
                    await ProductAPIService.renameProduct(product.id, product.name);
                } catch (error) {
                    console.error('Error renaming product: ', error);
                    window.rumReportError(error, (scope) => {
                        scope.setContext('product', {
                            id: product.id
                        });
                    });
                } finally {
                    blockUI.stop();
                    $timeout(() => $scope.$apply());
                    productPrevState = null;
                }
            }
        };

        $scope.goToOptions = function () {
            $location.path('/options');
        };

        $scope.goToLibraries = function () {
            $location.path('/libraries');
        };

        $scope.getThumbUrl = function (thumbPath) {
            if (thumbPath) {
                return buildCloudFrontUrl(thumbPath, true);
            }
            return '';
        };

        window.Appcues?.on('flow_started', function (event) {
            AppCuesService.setCurrentFlow(event.flowId);
        });

        $scope.copyTemplateId = function ($event) {
            $event.stopPropagation();
            const productId = $event.currentTarget.innerText.trim();
            const textAreaHiddenCopy = document.createElement('textarea');
            textAreaHiddenCopy.value = productId;
            $event.currentTarget.appendChild(textAreaHiddenCopy);
            textAreaHiddenCopy.select();

            try {
                document.execCommand('copy');
                $scope.templateIdCopied = productId;
            } catch (err) {
                console.log('Unable to copy to clipboard.', err);
            }

            $timeout(() => {
                $scope.templateIdCopied = '';
            }, 1500);
            $event.currentTarget.removeChild(textAreaHiddenCopy);
        };

        $scope.sortTemplates = function (sortBy) {
            if ($scope.sortBy == sortBy) {
                $scope.sortMode = $scope.sortMode == 'ASC' ? 'DESC' : 'ASC';
            } else {
                $scope.sortBy = sortBy;
            }
            $scope.getProducts();
        };

        $scope.clearSearchString = function () {
            $scope.searchString = '';
            $scope.getProducts();
        };

        $scope.templateSortChange = function () {
            $scope.getProducts();
        };
        $scope.getProductTemplateRelations = function (productId, index, product, $event) {
            $event.stopPropagation();
            blockUI.start('Loading...');
            ProductAPIService.getProductTemplateRelations(productId)
                .then(function (data) {
                    const { Products, OptionSets, Clients } = data;
                    $scope.templateRelationDetails.title = product.name;
                    $scope.templateRelationDetails.templateId = product.id;
                    $scope.templateRelationDetails.Products = Products;
                    $scope.templateRelationDetails.OptionSets = OptionSets;
                    $scope.templateRelationDetails.Clients = Clients;
                    $scope.templateRelationDetails.isOpen = true;
                    $scope.templateRelationDetails.showDeleteMessage = false;
                })
                .catch(function (error) {
                    if (error?.data?.type == 'ProductTemplateRelationLinked') {
                        product.Linked = false;
                    }
                })
                .finally(() => {
                    blockUI.stop();
                });
        };

        $scope.bulkDelete = () => {
            var confirm = $mdDialog
                .confirm()
                .title('Delete template(s)')
                .htmlContent(
                    'Are you sure you want to delete "<b>' + $scope.templatesSelectedCount + ' template(s)</b>"?'
                )
                .ok('Delete')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(
                async function () {
                    // Delete all products
                    const selectedIds = $scope.getSelectedTemplates().map((product) => product.ProductId);
                    ProductAPIService.deleteProductRange(selectedIds)
                        .then(() => {
                            $scope.getProducts();
                        })
                        .catch((error) => {
                            console.log(error);
                            $mdDialog.show(
                                $mdDialog
                                    .alert()
                                    .parent(document.body)
                                    .clickOutsideToClose(true)
                                    .title('Delete template(s)')
                                    .htmlContent(
                                        `An error occurred while deleting the template(s). Please try again later.`
                                    )
                                    .ok('OK')
                            );
                        });
                },
                function () {
                    // Do nothing
                }
            );
        };

        $scope.getUnlinkedTemplates = () => $scope.filteredProducts.filter((item) => !item.Linked);
        $scope.getLinkedTemplates = () => $scope.filteredProducts.filter((item) => item.Linked);

        $scope.getAreAllTemplatesSelected = () => {
            const templates = $scope.getUnlinkedTemplates();
            return templates?.length > 0 && templates.every((item) => item.selected);
        };
        $scope.getSelectedTemplates = () => $scope.getUnlinkedTemplates()?.filter((item) => item.selected);

        $scope.selectAllTemplates = (value) => {
            try {
                for (const product of $scope.getUnlinkedTemplates()) {
                    if (product.selected !== value) {
                        product.selected = value;
                    }
                }
                $scope.areAllTemplatesSelected = $scope.getAreAllTemplatesSelected();
                $scope.templatesSelectedCount = $scope.getSelectedTemplates()?.length;
            } catch (error) {
                console.error('Error selecting all templates:', error);
            }
        };

        $scope.selectTemplate = (product) => ({
            handler: (value) => {
                product.selected = value;
                $scope.areAllTemplatesSelected = $scope.getAreAllTemplatesSelected();
                $scope.templatesSelectedCount = $scope.getSelectedTemplates()?.length;
            }
        });

        $scope.isBulkDeleteEnabled = () => !['linked', 'deleted'].includes($scope.templateSort);

        $scope.canDeleteTemplate = async function (product) {
            return await TemplatePermissionsService.canDelete(product.id, $scope);
        };

        $scope.getShowFullAccessFilter = () => $scope.showFullAccessFilter;

        $scope.onFullAccessFilterChange = function () {
            $scope.filterFullAccessOnly = !$scope.filterFullAccessOnly;
            $scope.getProducts();
        };

        $scope.templateVersionRestored = (template) => {
            $mdToast
                .show(
                    $mdToast
                        .simple()
                        .textContent(
                            `A previous version of the template ${template.templateName} was restored and new one was created with id ${template.templateId}.`
                        )
                        .action('X')
                        .position('top right')
                        .hideDelay(0)
                        .toastClass('md-toast-black')
                )
                .then(function (response) {
                    if (response == 'ok') {
                        $mdToast.hide();
                    }
                });
            $scope.onScopesAuditLogModalClose();
            $scope.getProducts();
        };
    }
})();
